import { render, staticRenderFns } from "./GridNavItem.vue?vue&type=template&id=f6caf254&scoped=true&"
import script from "./GridNavItem.vue?vue&type=script&lang=ts&"
export * from "./GridNavItem.vue?vue&type=script&lang=ts&"
import style0 from "./GridNavItem.vue?vue&type=style&index=0&id=f6caf254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6caf254",
  null
  
)

export default component.exports